"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Links = void 0; // eslint-disable-next-line max-len

var confirmation = function confirmation(locale, type, locationNumber) {
  return "/" + locale + "/order/" + type + "/stores/" + locationNumber + "/checkout/order-confirmed";
};

var Links = {
  confirmation: confirmation
};
exports.Links = Links;